import { useRef } from "react";
import { toast } from "sonner";
import { Upload, X, Building2, User } from "lucide-react";

const MAX_BYTES = 800 * 1024; // 800KB pre-encode → within backend cap

export default function ImageUpload({ value, onChange, kind = "avatar", testId = "image-upload" }) {
  const inputRef = useRef(null);
  const isLogo = kind === "logo";

  const onFile = (e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    if (!f.type.startsWith("image/")) return toast.error("Please choose an image file.");
    if (f.size > MAX_BYTES) return toast.error("Image is too large (max 800KB).");
    const reader = new FileReader();
    reader.onload = () => onChange(reader.result);
    reader.onerror = () => toast.error("Could not read file.");
    reader.readAsDataURL(f);
  };

  const size = "h-24 w-24";
  const Icon = isLogo ? Building2 : User;
  const shape = isLogo ? "rounded-2xl" : "rounded-full";

  return (
    <div className="flex items-center gap-4" data-testid={testId}>
      <div className={`relative flex ${size} items-center justify-center ${shape} overflow-hidden border border-[color:var(--hairline)] bg-[color:var(--soft)]`}>
        {value ? (
          <img src={value} alt="" className="h-full w-full object-cover" />
        ) : (
          <Icon className="h-8 w-8 text-[color:var(--ink-soft)]" />
        )}
      </div>
      <div className="flex flex-col gap-2">
        <input ref={inputRef} type="file" accept="image/*" className="hidden" onChange={onFile} data-testid={`${testId}-input`} />
        <button type="button" onClick={() => inputRef.current?.click()} data-testid={`${testId}-pick`}
          className="inline-flex items-center gap-1.5 rounded-full border border-[color:var(--hairline)] bg-[color:var(--surface)] px-4 py-2 text-sm font-semibold text-[color:var(--ink)] transition-colors hover:border-[color:var(--ink)]">
          <Upload className="h-3.5 w-3.5" /> {value ? "Replace" : "Upload"}
        </button>
        {value && (
          <button type="button" onClick={() => onChange(null)} data-testid={`${testId}-remove`}
            className="inline-flex items-center gap-1.5 text-xs font-medium text-[color:var(--ink-soft)] hover:text-[color:var(--brand-red)]">
            <X className="h-3.5 w-3.5" /> Remove
          </button>
        )}
        <p className="text-[11px] text-[color:var(--ink-soft)]">PNG or JPG, up to 800KB</p>
      </div>
    </div>
  );
}
